import {
  Alert,
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from '@mui/material';
import { useEffect, useState } from 'react';
import fetchCompanyData from '../../network/fetch_company_data';
import CloseIcon from '@mui/icons-material/Close';

const NameChecker = ({
  label,
  onNameAvailable,
  loading,
  setLoading,
  error = false,
}) => {
  const [companyName, setCompanyName] = useState('');
  const [companyType, setCompanyType] = useState('LTD');
  const [companyNameSearched, setCompanyNameSearched] = useState('');
  const [isRegistered, setIsRegistered] = useState(null);
  const companyTypes = [
    { value: 'Limited', label: 'Limited' },
    { value: 'LTD', label: 'LTD' },
  ];

  const handleCompanyNameChange = (event) => {
    setCompanyName(event.target.value);
  };

  const handleCompanyTypeChange = (event) => {
    setCompanyType(event.target.value);
  };

  const fetchData = async (fullCompanyName) => {
    setCompanyNameSearched(() => fullCompanyName);
    try {
      const data = await fetchCompanyData(fullCompanyName);
      return data;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    if (onNameAvailable) {
      if (!isRegistered) {
        const fullCompanyName = `${companyName} ${companyType}`;
        onNameAvailable(fullCompanyName);
      } else {
        onNameAvailable('');
      }
    }
  }, [isRegistered]);

  const checkCompanyName = async () => {
    setLoading(true);
    const fullCompanyName = `${companyName} ${companyType}`;
    try {
      const data = await fetchData(fullCompanyName);
      if (data && data?.items) {
        const isNameAlreadyRegistered = data.items.length > 0 ? true : false;
        setIsRegistered(() => isNameAlreadyRegistered);
      } else {
        setIsRegistered(() => true);
      }
    } catch (error) {
      console.error('Error checking company name:', error);
      setIsRegistered(() => true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={8}>
          <TextField
            fullWidth
            label={label}
            value={companyName}
            error={error}
            onChange={handleCompanyNameChange}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            select
            fullWidth
            value={companyType}
            onChange={handleCompanyTypeChange}
          >
            {companyTypes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={checkCompanyName}
          >
            Check
          </Button>
        </Grid>
      </Grid>
      <Collapse in={alert !== null}>
        {isRegistered !== null && !loading && (
          <Alert
            severity={isRegistered ? 'error' : 'success'}
            variant="outlined"
            sx={{
              backgroundColor: 'transparent',
              color: (theme) =>
                isRegistered
                  ? theme.palette.error.main
                  : theme.palette.success.main,
              padding: 0,
              margin: 0,
              border: 'none',
              boxShadow: 'none',
              textAlign: 'left',
            }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => setIsRegistered(null)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {isRegistered
              ? `Sorry, the company name '${companyNameSearched}' is already registered.`
              : `Congratulations, the company name '${companyNameSearched}' is available to register!.`}
          </Alert>
        )}
      </Collapse>
    </Box>
  );
};

export default NameChecker;
